import DeviceLinkFileUpload from '@features/isc/DeviceLinkFileUpload';
import UserPreferences from '@features/isc/UserPreferences';
import React from 'react';

import { Navigate, RouteObject, createBrowserRouter } from 'react-router-dom';
import DeviceRenamePage from 'src/pages/isc/DeviceRenamePage';
import IscLayout from 'src/pages/isc/layout/IscLayout';
import RecordersPage from 'src/pages/milestones/RecordersPage';
import SitesPage from 'src/pages/milestones/SitesPage';
import TreePage from 'src/pages/milestones/TreePage';
import MilestonesLayout from 'src/pages/milestones/layout/MilestonesLayout';
import ProtectedRoute from '@components/ProtectedRoute';
import { AuthCallback } from '@features/auth/routes/AuthCallbackRoute';
import UnlinkDevices from 'src/features/isc/UnlinkDevices';

export enum AppPaths {
  AuthCallback = '/auth/callback',
  Devices = '/devices',
  Milestone = '/milestones',
  RecordersView = '/milestones/recorders',
  Sites = 'sites',
  SitesView = '/milestones/sites',
  TreeRecordersView = '/milestones/tree/recorders',
  TreeSingleView = '/milestones/tree',
}

const routes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute>
        <IscLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate replace to={AppPaths.Devices} />,
      },
      {
        path: AppPaths.Devices,
        element: <DeviceRenamePage />,
      },
      {
        path: AppPaths.AuthCallback,
        element: <AuthCallback />,
      },
    ],
  },
  {
    path: AppPaths.Milestone,
    element: (
      <ProtectedRoute>
        <MilestonesLayout />
        <DeviceLinkFileUpload />
        <UnlinkDevices />
        <UserPreferences />
      </ProtectedRoute>
    ),
    children: [
      {
        path: AppPaths.Milestone,
        element: <Navigate replace to={AppPaths.RecordersView} />,
      },
      {
        path: AppPaths.SitesView,
        element: <SitesPage />,
      },
      {
        path: AppPaths.RecordersView,
        element: <RecordersPage />,
      },
      {
        path: AppPaths.TreeSingleView, // /milestones/tree?site=site1 or /milestones/tree?recorder=recorder1
        element: <TreePage />, // using path params will allow us to save tree or cache, if needed in the future
      },
      {
        path: AppPaths.TreeRecordersView, // /milestones/tree/recorders (no search params)
        element: <TreePage />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
